const inquiryTypes = [
  {
    icon: "ri-mail-send-line",
    color: "#1A4D3C",
    title: "General Inquiries",
    desc: "Questions about Harambee Global Ventures, our mission, our team, or how we can support your financial journey. We welcome all introductory conversations.",
    cta: "Send a General Inquiry",
    anchor: "#contact-form",
    tag: "General",
  },
  {
    icon: "ri-graduation-cap-line",
    color: "#1A4D3C",
    title: "Trading Academy Questions",
    desc: "Interested in our financial education programs, curriculum, enrollment, or upcoming cohorts? Our team is happy to walk you through the Trading Academy experience.",
    cta: "Ask About the Academy",
    anchor: "#contact-form",
    tag: "Education",
  },
  {
    icon: "ri-user-settings-line",
    color: "#1A4D3C",
    title: "Advisory Consultations",
    desc: "Seeking personalized advisory support for investor readiness, financial planning, or cross-border opportunity? Schedule a consultation with our advisory team.",
    cta: "Request a Consultation",
    anchor: "/advisory",
    tag: "Advisory",
    isLink: true,
  },
  {
    icon: "ri-shake-hands-line",
    color: "#1A4D3C",
    title: "Partnership Opportunities",
    desc: "Representing an institution, community organization, or mission-aligned venture? Explore how we can build a structured collaboration pathway together.",
    cta: "Explore Partnerships",
    anchor: "/partnerships",
    tag: "Partnerships",
    isLink: true,
  },
  {
    icon: "ri-mic-2-line",
    color: "#1A4D3C",
    title: "Media & Speaking Requests",
    desc: "Interested in featuring Harambee Global Ventures in a publication, podcast, panel, or speaking engagement? We welcome thoughtful media and speaking opportunities.",
    cta: "Submit a Media Request",
    anchor: "#contact-form",
    tag: "Media",
  },
];

export default function InquiryOptions() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            How Can We Help
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-4">
            Choose Your Inquiry Pathway
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed max-w-2xl mx-auto">
            Select the pathway that best matches your needs. Each inquiry type is handled by the appropriate team to ensure you receive the most relevant and timely response.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {inquiryTypes.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-[#E8E4DC] p-7 flex flex-col hover:border-[#C9A961]/50 transition-all group"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10">
                  <i className={`${item.icon} text-[#1A4D3C] text-xl`} />
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-widest text-[#C9A961] bg-[#C9A961]/10 px-3 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-[#2B2D2F] mb-3">
                {item.title}
              </h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed flex-1 mb-6">
                {item.desc}
              </p>
              {item.isLink ? (
                <a
                  href={item.anchor}
                  className="inline-flex items-center gap-2 text-[#1A4D3C] text-sm font-semibold hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  {item.cta} <i className="ri-arrow-right-line" />
                </a>
              ) : (
                <a
                  href={item.anchor}
                  className="inline-flex items-center gap-2 text-[#1A4D3C] text-sm font-semibold hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  {item.cta} <i className="ri-arrow-right-line" />
                </a>
              )}
            </div>
          ))}

          {/* Decorative 6th card */}
          <div className="bg-[#1A4D3C] rounded-lg p-7 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mb-5">
                <i className="ri-compass-3-line text-[#C9A961] text-xl" />
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-white mb-3">
                Not Sure Where to Start?
              </h3>
              <p className="text-white/65 text-sm leading-relaxed mb-6">
                Use the general contact form below and briefly describe what you are looking for. Our team will route your inquiry to the right person.
              </p>
            </div>
            <a
              href="#contact-form"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#C9A961] text-[#1A2B1F] text-sm font-semibold hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
            >
              Use the Contact Form <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
